import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as LogoImage } from '../../images/logo-text.svg';

import css from './Logo.module.scss';


const Logo: React.FC = () => {
  return (
    <div className={css.logo}>
        <Link to="/">
            <LogoImage className={css["logo-image"]}/>
        </Link>
    </div>
  );
};

export default Logo;